<template>

  <ss-modal
    class="xl"
    v-if="isModalVisible"
    title="Title"
    intro="bounceIn"
    outro="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      <template v-if="isEdit">Edycja dokumentu</template>
      <template v-else>Nowy dokument</template>
      <i class="close" @click="closeModal()"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body" >
      <document :props.sync="selectedDocument" />
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal()"
        :class="{ disabled : actionInProgress }"
        theme="danger">
        <i class="material-icons">close</i> Zamknij
      </d-button>
      <d-button
        @click.prevent="saveNewDocument"
        :class="{
          'ml-3': true,
          'isLoading': actionInProgress
        }"
        theme="success">
        <i class="material-icons">save</i> Zapisz
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import LarErrors from '@/helpers/Errors';
import SsModal from '@/components/common/SsModal';
import Document from '@/components/client//Document';

export default {
  name: 'DocumentFormModal',
  components: {
    LarErrors,
    SsModal,
    Document
  },
  props: {
    isModalVisible: {
      type: Boolean,
      default: false
    },
    selectedDocument: {
      type: Object,
      default: null
    }
  },
  computed: {
    isEdit () {
      return this.selectedDocument && this.selectedDocument.id;
    }
  },
  data () {
    return {
      actionInProgress: false
    }
  },
  methods: {
    saveNewDocument(){
      let data = new FormData();
      Vue.appendFormdata(data, this.selectedDocument);

      this.actionInProgress = true;
      axios.post('api/clients/save-document', data).then(response => {
      Vue.swal({
        type: 'success',
        title: 'Dokument został dodany.',
        showConfirmButton: true,
      }).then(() => {
        this.$bus.$emit('contract-reload-documents', !this.isEdit);
        this.closeModal();
      });
      this.actionInProgress = false;
      }).catch((error) =>{
        this.actionInProgress = false;
        console.log(error);
        LarErrors.record(error.response.data.errors)
      })
    },
    closeModal () {
      this.$bus.$emit('document-form-modal-close');
    }
  }
}
</script>
